export default __webpack_public_path__ + "static/thumb-landscape-faf49e9e1ad5c8cfe9deff69a88b5332.jpg";